import BPO from "../../components/Service/BPO";
import Container from "../../components/ui/Container";

const BPOPage: React.FC = () => {
  return (
   <Container>
        <BPO />
    </Container>

  );
};

export default BPOPage;

